// File: app/src/utils/generationCarryOver.js
//
// "Regenerate" used to reopen the Generate dialog on a blank form, so tweaking
// one thing about the session on screen meant re-entering everything. These
// helpers carry the answers that produced the current plan back into the form.
//
// The record is keyed by the plan it generated rather than being globally
// sticky: a cleared session, or a saved session loaded afterwards, opens clean
// instead of inheriting knobs that never belonged to it.

/**
 * The record to persist after a successful generation, or null when there is
 * nothing worth carrying (a plan with no id cannot be matched again).
 *
 * `programmeContext` is caller-supplied background from a programme slot, not a
 * field the dialog can show or clear, so it is dropped — it is re-supplied by
 * whoever opens the dialog next.
 */
export const buildCarryOverRecord = (planId, planConfig) => {
  if (!planId || !planConfig) return null;
  const { programmeContext, ...config } = planConfig;
  return { planId, config };
};

/**
 * The carried config for `planId`, or null when the stored record belongs to a
 * different plan (or there is none).
 */
export const carriedConfigForPlan = (record, planId) => {
  if (!planId || !record || record.planId !== planId) return null;
  return record.config || null;
};
